import { Box, Text } from '@opendoor/bricks-next';
import { formatCurrency } from '@opendoor/shared-fe/formatUtils';

interface PricingTraditionalProps {
  listPrice?: number | null;
}

export const PricingTraditional = ({ listPrice }: PricingTraditionalProps) => {
  return (
    <Box flexDirection="row" alignItems="center">
      <Text typography="$headerMedium" tag="h2" color="$contentPrimary" pb={24}>
        {listPrice ? formatCurrency(listPrice) : 'Price not available'}
      </Text>
    </Box>
  );
};
